// Brand + static content for ZEBO India Private Limited
export const BRAND = {
  name: "ZEBO",
  full: "ZEBO India Private Limited",
  logo: "/logo.png",
  tagline: "Interiors, engineered beautifully.",
  phone: "+91 90512 93651",
  phoneRaw: "919051293651",
  email: "connect@thezebo.com",
  address: "The Chambers, 1865, Rajdanga Main Rd, opp. Gitanjali Stadium, Sector E, East Kolkata Twp, Kolkata, West Bengal 700107",
  website: "www.visafex.com",
  cin: "U42900WB2025PTC284342",
  gstin: "19AACCZ8082C1Z2",
  instagram: "https://www.instagram.com/thezebo/",
  facebook: "https://www.facebook.com/thezebo/",
  // Once your Google Business Profile is live, replace with your exact review link
  // (Business Profile -> Ask for reviews -> copy link, e.g. https://g.page/r/XXXX/review)
  reviewUrl: "https://www.google.com/maps/search/?api=1&query=ZEBO+India+Private+Limited+Rajdanga+Main+Rd+Kolkata",
};

const u = (id, w = 1400) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  // Hero — modern minimal kitchen with warm wood + marble
  heroKitchen: u("1600607687939-ce8a6c25118c", 1900),
  // Modern residential
  living1:   u("1618221195710-dd6b41faaea6"), // Scandinavian modern living
  living2:   u("1600210492486-724fe5c67fb0"), // Contemporary open-plan living
  living3:   u("1583847268964-b28dc8f51f92"), // Warm minimal lounge
  kitchen1:  u("1600585154526-990dced4db0d"), // Modern island kitchen
  kitchen2:  u("1556909114-f6e7ad7d3136"),    // Handleless white modular kitchen
  kitchen3:  u("1556909195-27e3ce6ec22a"),    // Dark modern kitchen
  bedroom1:  u("1616486338812-3dadae4b4ace"), // Modern master bedroom
  bedroom2:  u("1616594039964-ae9021a400a0"), // Boutique bedroom
  wardrobe1: u("1615529182904-14819c35db37"), // Walk-in wardrobe
  wardrobe2: u("1631679706909-1844bbd07221"), // Luxe wardrobe
  // Commercial + before/after — AI-generated matched pairs (same physical space,
  // BEFORE = raw shell, AFTER = fully finished). Generated by /app/scripts/generate_ba_pairs.py
  officeAfter:     "/ba/office-after.jpg",
  officeBefore:    "/ba/office-before.jpg",
  cafeAfter:       "/ba/cafe-after.jpg",
  cafeBefore:      "/ba/cafe-before.jpg",
  retailAfter:     "/ba/retail-after.jpg",
  retailBefore:    "/ba/retail-before.jpg",
  restaurantAfter: "/ba/restaurant-after.jpg",
  restaurantBefore:"/ba/restaurant-before.jpg",
};

export const SERVICES = [
  {
    id: "full-home",
    no: "01",
    title: "Full-Home Interiors",
    desc: "End-to-end design for living rooms, bedrooms & beyond — a single, cohesive language across every room you live in.",
    img: IMAGES.living1,
  },
  {
    id: "modular-kitchen",
    no: "02",
    title: "Modular Kitchens",
    desc: "Precision-engineered kitchens with premium finishes, smart storage and hardware built to last a lifetime.",
    img: IMAGES.kitchen1,
  },
  {
    id: "wardrobes",
    no: "03",
    title: "Wardrobes & Storage",
    desc: "Bespoke wardrobes and storage systems tailored to your space, your things and the way you actually live.",
    img: IMAGES.wardrobe1,
  },
  {
    id: "commercial",
    no: "04",
    title: "Turnkey Commercial Interiors",
    desc: "Offices, restaurants, cafés, salons and retail — brand-forward interiors delivered turnkey, with a single team for design, build and handover.",
    img: IMAGES.living2,
  },
];

export const MANIFESTO = [
  { no: "01", title: "Design that listens", body: "We start with how you live — not a catalogue. Every plan begins with your routines, light and space." },
  { no: "02", title: "Engineered to last", body: "Factory-grade modular systems, marine-ply cores and hardware rated for decades of daily use." },
  { no: "03", title: "One accountable team", body: "A single studio owns design, manufacturing and install — no finger-pointing, no surprises." },
  { no: "04", title: "Transparent to the rupee", body: "Itemised quotes, fixed timelines and a flat, honest process from first sketch to final handover." },
];

export const PROCESS = [
  { no: "01", title: "Consult", body: "Share your space & vision in a free design consultation." },
  { no: "02", title: "Design", body: "3D designs, material choices and a transparent quote." },
  { no: "03", title: "Manufacture", body: "Precision production in our modular facility." },
  { no: "04", title: "Install", body: "On-time install with a dedicated project manager." },
];

export const GALLERY = [
  { slug: "marble-oak-living-ballygunge", img: IMAGES.living1, title: "Marble & Oak Living", tag: "Full Home", span: "lg:col-span-7" },
  { slug: "handleless-modular-kitchen-newtown", img: IMAGES.kitchen2, title: "Handleless Kitchen", tag: "Modular Kitchen", span: "lg:col-span-5" },
  { slug: "walk-in-wardrobe-saltlake", img: IMAGES.wardrobe1, title: "Walk-in Wardrobe", tag: "Wardrobe", span: "lg:col-span-5" },
  { slug: "warm-minimal-lounge-rajdanga", img: IMAGES.living3, title: "Warm Minimal Lounge", tag: "Full Home", span: "lg:col-span-7" },
  { slug: "island-modular-kitchen-kasba", img: IMAGES.kitchen1, title: "Island Kitchen", tag: "Modular Kitchen", span: "lg:col-span-6" },
  { slug: "sliding-glass-wardrobe-garia", img: IMAGES.wardrobe2, title: "Sliding Glass Storage", tag: "Wardrobe", span: "lg:col-span-6" },
  { slug: "boutique-bedroom-alipore", img: IMAGES.bedroom1, title: "Boutique Master Bedroom", tag: "Full Home", span: "lg:col-span-4" },
  { slug: "dark-modern-kitchen-newtown", img: IMAGES.kitchen3, title: "Matte Graphite Kitchen", tag: "Modular Kitchen", span: "lg:col-span-4" },
  { slug: "layered-lounge-alipore", img: IMAGES.living2, title: "Open-Plan Lounge", tag: "Full Home", span: "lg:col-span-4" },
];

// Before / after transformations — used on Home page section
export const BEFORE_AFTER = [
  {
    slug: "salt-lake-tech-office",
    title: "Salt Lake Tech Office",
    category: "Commercial · Office",
    location: "Salt Lake, Kolkata",
    duration: "58 days",
    scope: "3,400 sqft turnkey",
    before: IMAGES.officeBefore,
    after: IMAGES.officeAfter,
  },
  {
    slug: "rajdanga-cafe",
    title: "Rajdanga Neighbourhood Café",
    category: "Commercial · Café",
    location: "Rajdanga, Kolkata",
    duration: "34 days",
    scope: "1,100 sqft turnkey",
    before: IMAGES.cafeBefore,
    after: IMAGES.cafeAfter,
  },
  {
    slug: "park-street-boutique",
    title: "Park Street Retail Boutique",
    category: "Commercial · Retail",
    location: "Park Street, Kolkata",
    duration: "42 days",
    scope: "780 sqft turnkey",
    before: IMAGES.retailBefore,
    after: IMAGES.retailAfter,
  },
  {
    slug: "ranchi-fine-dine",
    title: "Ranchi Fine-Dine Restaurant",
    category: "Commercial · Restaurant",
    location: "Ranchi, Jharkhand",
    duration: "76 days",
    scope: "2,600 sqft turnkey",
    before: IMAGES.restaurantBefore,
    after: IMAGES.restaurantAfter,
  },
];

export const CASE_STUDIES = {
  "marble-oak-living-ballygunge": {
    title: "Marble & Oak Living Room",
    location: "Ballygunge, Kolkata",
    category: "Full Home Interior",
    cover: IMAGES.living1,
    meta: { Area: "1,650 sq ft", Scope: "Living + Dining", Duration: "9 weeks", Style: "Warm Contemporary" },
    intro: "A light-filled 3BHK living room in Ballygunge reimagined with Italian marble flooring, warm oak veneer and layered lighting for a calm, elevated everyday.",
    body: [
      "The brief was a versatile living and dining space for a young Kolkata family that entertains often. We anchored the room with a full-height oak veneer TV unit and a book-matched marble feature wall.",
      "Concealed cove lighting and slim profile spotlights let the family shift the mood from bright and social to soft and intimate — a hallmark of thoughtful full-home interior design.",
    ],
    gallery: [IMAGES.living1, IMAGES.living2, IMAGES.kitchen1],
  },
  "handleless-modular-kitchen-newtown": {
    title: "Handleless Modular Kitchen",
    location: "New Town, Kolkata",
    category: "Modular Kitchen",
    cover: IMAGES.kitchen2,
    meta: { Area: "180 sq ft", Scope: "Modular Kitchen", Duration: "6 weeks", Style: "Modern Minimal" },
    intro: "A sleek handleless modular kitchen in New Town with acrylic shutters, quartz countertops and floor-to-ceiling tall units for effortless storage.",
    body: [
      "We maximised a compact footprint with a practical L-shape layout, soft-close hardware and a dedicated tall unit tower for appliances and pantry.",
      "Fingerprint-resistant matte acrylic shutters and a stain-proof quartz counter make this one of the most low-maintenance modular kitchens we've built in Kolkata.",
    ],
    gallery: [IMAGES.kitchen2, IMAGES.kitchen1, IMAGES.living1],
  },
  "walk-in-wardrobe-saltlake": {
    title: "Walk-in Wardrobe & Dresser",
    location: "Salt Lake, Kolkata",
    category: "Wardrobe & Storage",
    cover: IMAGES.wardrobe1,
    meta: { Area: "90 sq ft", Scope: "Walk-in Wardrobe", Duration: "5 weeks", Style: "Luxe Classic" },
    intro: "A boutique-style walk-in wardrobe in Salt Lake with backlit glass shutters, a central island dresser and soft-close drawers.",
    body: [
      "Every metre was planned around the couple's wardrobe: dedicated hanging, shelving and accessory drawers with velvet-lined inserts.",
      "Backlit frosted-glass shutters and warm LED profiles give the space a calm, hotel-suite feel while keeping everything visible and organised.",
    ],
    gallery: [IMAGES.wardrobe1, IMAGES.wardrobe2, IMAGES.living2],
  },
  "warm-minimal-lounge-rajdanga": {
    title: "Warm Minimal Lounge",
    location: "Rajdanga, Kolkata",
    category: "Full Home Interior",
    cover: IMAGES.living2,
    meta: { Area: "1,200 sq ft", Scope: "Living + Foyer", Duration: "8 weeks", Style: "Indian Contemporary" },
    intro: "A warm, minimal lounge near our Rajdanga studio blending fluted wood panelling, brass accents and earthy upholstery.",
    body: [
      "The palette pairs muted clay tones with walnut and brushed brass, creating a serene backdrop that still feels rooted in an Indian contemporary sensibility.",
      "Custom joinery hides everyday clutter, while a statement arch defines the foyer — a small architectural moment that gives the home a signature entrance.",
    ],
    gallery: [IMAGES.living2, IMAGES.living1, IMAGES.wardrobe1],
  },
  "island-modular-kitchen-kasba": {
    title: "Island Modular Kitchen",
    location: "Kasba, Kolkata",
    category: "Modular Kitchen",
    cover: IMAGES.kitchen1,
    meta: { Area: "240 sq ft", Scope: "Island Kitchen", Duration: "7 weeks", Style: "Warm Contemporary" },
    intro: "An open-plan island kitchen in Kasba designed for cooking, casual dining and conversation — all in one generous space.",
    body: [
      "The central island doubles as prep space and breakfast counter, with deep pan drawers and an integrated hob for a true social kitchen.",
      "Two-tone shutters in deep navy and warm oak tie the kitchen into the adjoining living area for a cohesive full-home look.",
    ],
    gallery: [IMAGES.kitchen1, IMAGES.kitchen2, IMAGES.living1],
  },
  "sliding-glass-wardrobe-garia": {
    title: "Sliding Glass Wardrobe",
    location: "Garia, Kolkata",
    category: "Wardrobe & Storage",
    cover: IMAGES.wardrobe2,
    meta: { Area: "70 sq ft", Scope: "Bedroom Wardrobe", Duration: "4 weeks", Style: "Modern Minimal" },
    intro: "A space-saving sliding wardrobe in Garia with lacquered glass shutters and a smart internal layout for a compact bedroom.",
    body: [
      "Sliding shutters were the right call for a tight bedroom — zero swing clearance needed, with a mirror panel that visually doubles the room.",
      "Inside, a mix of hanging, shelves and pull-out drawers gives a family of three generous, well-organised storage in a small footprint.",
    ],
    gallery: [IMAGES.wardrobe2, IMAGES.wardrobe1, IMAGES.kitchen2],
  },
};

export const TESTIMONIALS = [
  { name: "Ananya & Rohit Chatterjee", place: "New Town, Kolkata", quote: "ZEBO turned a bare 3BHK into a home that feels like us. The modular kitchen alone gets compliments every time someone visits.", rating: 5, project: "3 BHK Full Home" },
  { name: "Meera Nair", place: "Ballygunge, Kolkata", quote: "Transparent pricing, zero drama, delivered a week early. The wardrobes are ridiculously well made and the site team was on time every single day.", rating: 5, project: "Modular Kitchen + Wardrobes" },
  { name: "Karthik Rao", place: "Salt Lake, Kolkata", quote: "The 3D design ZEBO showed us was exactly what got built. That never happens. Genuinely premium finish and 10-year warranty is honoured.", rating: 5, project: "3 BHK Full Home" },
  { name: "Priya & Anirban Ghosh", place: "Rajdanga, Kolkata", quote: "We shortlisted six firms. ZEBO was the only one who gave us a real BOQ within 24 hours and stuck to it. Handover was on day 62 of a 60-day promise.", rating: 5, project: "4 BHK Duplex" },
  { name: "Sourav Banerjee", place: "Kasba, Kolkata", quote: "Small café fit-out done in 34 days. Design, kitchen equipment coordination, branded wall — one team. Would recommend to any restaurateur in Kolkata.", rating: 5, project: "Café Fit-out" },
  { name: "Riya & Anish Sen", place: "Behala, Kolkata", quote: "The AI Studio feature is what sold us — we saw our exact bedroom transformed before signing anything. Then reality matched the render.", rating: 5, project: "2 BHK Full Home" },
];

// Aggregate metrics for Review schema — update as you collect more Google reviews
export const REVIEW_STATS = {
  count: 47,          // total public reviews across Google + platforms
  averageRating: 4.9, // rounded to one decimal
};
